import { Api } from "../config/request";

export default {
  getDriverAssetsIssuedList(queryParams) {
    return Api.get(`/driver-assets/issuance/completed${queryParams}`);
  },
  getDriverMetaData(queryParams) {
    return Api.get(`/driver/basic-info${queryParams}`);
  },
  getDriverCities(queryParams) {
    return Api.get(`/driver/city${queryParams}`);
  },
  getOnboardingCenters(id) {
    return Api.get(`/onboarding-centre/city/${id}`);
  },
  getDriverAssetsAvailableList(queryParams) {
    return Api.get(`/driver-assets/issuable${queryParams}`);
  },
  addDriverAssets(payload, endpoint) {
    return Api.post(`/driver-assets/issuance/${endpoint}`, payload);
  },
  initiatePayment(payload) {
    return Api.post("/driver-assets/issuance/payment/initiate", payload);
  },
  discardAsset(payload) {
    return Api.post("/driver-assets/issuance/discard", payload);
  },
  getRecentAssetStatus(queryParams) {
    return Api.get(`/driver-assets/issuance/recent${queryParams}`);
  },
  getTransactionStatus(queryParams) {
    return Api.get(`/driver-assets/issuance/status${queryParams}`);
  },
  checkPaymentStatus(payload) {
    return Api.post("/driver-assets/issuance/payment/status", payload);
  },
  verifyOtp(payload) {
    return Api.post("/driver-assets/issuance/otp/verify", payload);
  },
  resendOtp(payload) {
    return Api.post("/driver-assets/issuance/otp/resend", payload);
  },
  bulkUploadDriverAssets(payload) {
    return Api.post("/driver-assets/bulk/modify", payload);
  },
  bulkUploadAssetsPickup(payload) {
    return Api.post("/driver-assets/bulk/pickup", payload);
  },
};
